// src/pages/admin/FraudPage.jsx
import { useState } from 'react'
import { Link } from 'react-router-dom'
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { Shield } from 'lucide-react'
import { adminFraudApi } from '../../api/services'
import { Card, CardBody, StatusBadge, PageSpinner, Button, Badge } from '../../components/common/ui'
import toast from 'react-hot-toast'

export default function FraudPage() {
  const qc = useQueryClient()
  const [severity, setSeverity] = useState('')
  const { data, isLoading } = useQuery({ queryKey: ['admin-fraud', severity], queryFn: () => adminFraudApi.index({ severity: severity||undefined }) })
  const review = useMutation({ mutationFn: ({id,...d}) => adminFraudApi.review(id, d), onSuccess: () => { toast.success('Updated'); qc.invalidateQueries(['admin-fraud']) } })

  if (isLoading) return <PageSpinner />
  const { flags = {}, stats = {} } = data?.data?.data || {}
  const list = flags.data || []

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-xl font-display font-bold flex items-center gap-2"><Shield size={20} className="text-pink" /> Fraud Flags</h1>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mb-6">
        {[['Open',stats.open_count??0],['High risk',stats.high_risk??0],['Actioned',stats.actioned??0],['This week',stats.this_week??0]].map(([l,v])=>(
          <div key={l} className="bg-white border border-border rounded-xl p-4 text-center"><p className="text-xl font-bold">{v}</p><p className="text-xs text-muted">{l}</p></div>
        ))}
      </div>
      <div className="flex gap-2 mb-4">
        {['','low','medium','high','critical'].map(s => (
          <button key={s} onClick={() => setSeverity(s)}
            className={`px-3 py-1.5 rounded-full text-xs font-bold border transition-all ${severity === s ? 'bg-pink text-white border-pink' : 'border-border text-muted hover:border-pink'}`}>
            {s || 'All'}
          </button>
        ))}
      </div>
      {list.length === 0 && <p className="text-sm text-muted text-center py-12">No open fraud flags.</p>}
      <div className="space-y-3">
        {list.map(f => (
          <Card key={f.id}>
            <CardBody className="flex items-center justify-between flex-wrap gap-3">
              <div>
                <div className="flex items-center gap-2 flex-wrap">
                  <Link to={`/admin/fraud/${f.user_id}`} className="font-bold text-sm hover:text-pink">{f.user?.name || `User #${f.user_id}`}</Link>
                  <Badge variant={f.severity === 'critical' ? 'red' : f.severity === 'high' ? 'red' : f.severity === 'medium' ? 'yellow' : 'grey'}>{f.severity}</Badge>
                  <StatusBadge status={f.status} />
                </div>
                <p className="text-xs text-muted">{f.rule}</p>
              </div>
              <div className="flex gap-2">
                <Button size="sm" variant="secondary" loading={review.isPending} onClick={() => review.mutate({ id: f.id, action: 'dismissed' })}>Dismiss</Button>
                <Button size="sm" variant="danger" loading={review.isPending} onClick={() => review.mutate({ id: f.id, action: 'actioned', ban_user: true })}>Ban User</Button>
              </div>
            </CardBody>
          </Card>
        ))}
      </div>
    </div>
  )
}
